/**
 * PageTransition — wraps each routed page in a Motion shell that
 * fades + slides on mount/unmount. Uses AnimatePresence at the
 * router level to actually run the exit animation.
 *
 * The transition is intentionally subtle — 250ms ease-out — so it
 * feels iOS-snappy rather than dramatic.
 */
import { motion } from 'motion/react';
import { type ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
}

export function PageTransition({ children }: PageTransitionProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -6 }}
      transition={{ duration: 0.28, ease: [0.32, 0.72, 0, 1] }}
    >
      {children}
    </motion.div>
  );
}
